function navigatePage(url) {
  window.location.assign(url);
}

export function createProviderResultsApi({ fetch = globalThis.fetch, navigate = navigatePage } = {}) {
  async function request(url, { signal } = {}) {
    const response = await fetch(url, { signal });
    if (!response.ok) {
      throw new Error(`Provider results request failed (${response.status})`);
    }
    const result = await response.json();
    return { result, resultCount: result.result_count };
  }

  return Object.freeze({ fetch: request, navigate });
}
